(function () {
  'use strict';

  var isYmmPage = document.body.classList.contains('template-collection')
    || document.body.classList.contains('template-index');
  if (!isYmmPage) return;

  var RESET_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">'
    + '<path fill="currentColor" d="M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 '
    + 'c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z"/>'
    + '<path fill="currentColor" d="M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 '
    + 'L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z"/>'
    + '</svg>';

  var strings = {};
  var cont = null;
  var enhanceTimer = null;
  var delegated = false;

  function loadStrings() {
    var el = document.getElementById('pr-ymm-locale-strings');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function setText(el, text) {
    if (el && text && el.textContent !== text) el.textContent = text;
  }

  function setPlaceholder(select, text) {
    if (!select || !text) return;
    var opt = select.querySelector('option[value="-1"]');
    if (opt && opt.textContent !== text) opt.textContent = text;
  }

  function syncSelectValueState(select) {
    if (!select) return;
    var li = select.closest('li');
    if (!li) return;
    if (select.value && select.value !== '-1') {
      li.classList.add('pr-ymm-has-value');
    } else {
      li.classList.remove('pr-ymm-has-value');
    }
  }

  function demoteToSpan(el) {
    if (!el || el.tagName === 'SPAN') return el;
    var span = document.createElement('span');
    span.id = el.id;
    if (el.className) span.className = el.className;
    span.textContent = el.textContent;
    el.parentNode.replaceChild(span, el);
    return span;
  }

  function ensureHeadingBlock(box) {
    var heading = box.querySelector('#ymm_label');
    if (!heading) return;

    if (document.body.classList.contains('template-collection')) {
      heading = demoteToSpan(heading);
    }

    if (!box.querySelector('.pr-ymm-heading-block')) {
      var block = document.createElement('div');
      block.className = 'pr-ymm-heading-block';
      heading.parentNode.insertBefore(block, heading);
      block.appendChild(heading);
    }

    var block = box.querySelector('.pr-ymm-heading-block');
    var sub = block.querySelector('.pr-ymm-subtitle');
    if (strings.subtitle) {
      if (!sub) {
        sub = document.createElement('p');
        sub.className = 'pr-ymm-subtitle';
        block.appendChild(sub);
      }
      setText(sub, strings.subtitle);
    }
    setText(heading, strings.heading || heading.textContent);
  }

  function syncAllSelectStates(box) {
    if (!box) return;
    box.querySelectorAll('select.ymm-filter').forEach(syncSelectValueState);
  }

  function applyTranslations(box) {
    strings = loadStrings();
    ensureHeadingBlock(box);

    var fieldMap = [
      { sel: 'li.field_1', label: strings.year, placeholder: strings.select_year },
      { sel: 'li.field_2', label: strings.make, placeholder: strings.select_make },
      { sel: 'li.field_3', label: strings.model, placeholder: strings.select_model },
      { sel: 'li.field_4', label: strings.parts, placeholder: strings.select_parts }
    ];

    fieldMap.forEach(function (f) {
      var li = box.querySelector(f.sel);
      if (!li) return;
      var label = li.querySelector('label.ymm_label');
      var select = li.querySelector('select.ymm-filter');
      if (label && f.label) {
        setText(label, f.label);
        if (select) select.setAttribute('aria-label', f.label);
      }
      setPlaceholder(select, f.placeholder);
      syncSelectValueState(select);
    });

    var searchLbl = box.querySelector('#ymm_search .ymm_btn_lbl');
    setText(searchLbl, strings.search || 'Search');

    var resetBtn = box.querySelector('#ymm_reset');
    if (resetBtn) {
      resetBtn.setAttribute('aria-label', strings.reset || 'Reset');
      if (!resetBtn.querySelector('svg')) {
        resetBtn.insertAdjacentHTML('afterbegin', RESET_SVG);
      }
    }

    var actions = box.querySelector('#ymm_actions');
    if (actions) {
      actions.removeAttribute('align');
      actions.style.width = 'auto';
    }
  }

  function fixLayout(box) {
    if (!box || box.classList.contains('vertical')) return;
    if (window.matchMedia('(min-width: 768px)').matches) {
      box.style.setProperty('display', 'flex', 'important');
    } else {
      box.style.removeProperty('display');
    }
  }

  function bindDelegation() {
    if (delegated || !cont) return;
    cont.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('select.ymm-filter')) {
        syncSelectValueState(e.target);
      }
    });
    cont.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('#ymm_reset')) {
        setTimeout(function () {
          var box = document.getElementById('ymm_searchbox');
          if (box) box.querySelectorAll('select.ymm-filter').forEach(syncSelectValueState);
        }, 150);
      }
    });
    delegated = true;
  }

  function enhance() {
    cont = document.getElementById('ymm_searchbox_cont');
    var box = document.getElementById('ymm_searchbox');
    if (!cont || !box) {
      if (cont) cont.classList.remove('pr-ymm-search--ready');
      return false;
    }

    applyTranslations(box);
    syncAllSelectStates(box);
    fixLayout(box);
    bindDelegation();
    cont.classList.add('pr-ymm-search--ready');
    return true;
  }

  function scheduleEnhance() {
    if (enhanceTimer) clearTimeout(enhanceTimer);
    enhanceTimer = setTimeout(enhance, 50);
  }

  function watch() {
    cont = document.getElementById('ymm_searchbox_cont');
    if (!cont) return;

    enhance();

    var obs = new MutationObserver(scheduleEnhance);
    obs.observe(cont, { childList: true, subtree: true, characterData: true });

    var checks = 0;
    var poll = setInterval(function () {
      checks++;
      enhance();
      if (checks > 60) clearInterval(poll);
    }, 500);

    setTimeout(function () { clearInterval(poll); }, 35000);
    window.addEventListener('resize', scheduleEnhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  document.addEventListener('globoFilterRenderCompleted', scheduleEnhance);
})();
